import React, { useState, useEffect } from "react";
import { BASE_URL } from "utils/constant";

const todayISO = () => new Date().toISOString().slice(0, 10);

const AddSubtaskModal = ({ handleSubmit, onClose, taskId, parentDueDate }) => {
  const [subtaskName, setSubtaskName] = useState("");
  const [subtaskDetails, setSubtaskDetails] = useState("");
  const [endDate, setEndDate] = useState(todayISO());
  const [priority, setPriority] = useState(2);
  const [taskMembers, setTaskMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("access");
  const authHeaders = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    fetchTaskMembers();
  }, [taskId]);

  const fetchTaskMembers = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/task/get-task-members/`, {
        method: "POST",
        headers: authHeaders,
        body: JSON.stringify({ task_id: taskId }),
      });

      const result = await response.json();
      if (result.status && result.data) {
        setTaskMembers(result.data);
      } else {
        console.error("Failed to fetch task members:", result.message);
      }
    } catch (error) {
      console.error("Error fetching task members:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMemberSelect = (memberId) => {
    setSelectedMembers((prev) => {
      if (prev.includes(memberId)) {
        return prev.filter((id) => id !== memberId);
      } else {
        return [...prev, memberId];
      }
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (parentDueDate && endDate > parentDueDate) {
      alert("Subtask due date cannot be after the parent task's due date.");
      return;
    }
    if (subtaskName.trim()) {
      handleSubmit({
        task_id: taskId,
        subtask_name: subtaskName.trim(),
        subtask_details: subtaskDetails.trim(),
        end_date: endDate,
        priority,
        assign_to: selectedMembers,
      });
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="bg-white rounded-lg w-full max-w-sm mx-4"
        style={{ maxHeight: "90vh", overflowY: "auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4">Add Subtask</h2>
          <form onSubmit={handleFormSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Subtask Name
              </label>
              <input
                type="text"
                value={subtaskName}
                onChange={(e) => setSubtaskName(e.target.value)}
                className="w-full p-2 border rounded"
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Details</label>
              <textarea
                value={subtaskDetails}
                onChange={(e) => setSubtaskDetails(e.target.value)}
                className="w-full p-2 border rounded"
                rows="3"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Due Date</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="w-full p-2 border rounded"
                max={parentDueDate || undefined}
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Priority</label>
              <select
                value={priority}
                onChange={(e) => setPriority(Number(e.target.value))}
                className="w-full p-2 border rounded"
              >
                <option value={1}>High</option>
                <option value={2}>Medium</option>
                <option value={3}>Low</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Assign To
              </label>
              {loading ? (
                <div>Loading members...</div>
              ) : (
                <div className="max-h-40 overflow-y-auto border rounded p-2">
                  {taskMembers.map((member) => (
                    <div
                      key={member.id}
                      className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleMemberSelect(member.id)}
                    >
                      <input
                        type="checkbox"
                        checked={selectedMembers.includes(member.id)}
                        onChange={() => {}}
                        className="mr-2"
                      />
                      <span>
                        {member.first_name} {member.last_name}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="flex justify-end space-x-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              >
                Add Subtask
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSubtaskModal;
